import { render } from "./Info.vue?vue&type=template&id=1ecdad17&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=1ecdad17&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-1ecdad17"

export default script